/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
Shopify.theme.jsCart = {
  init: function ($section) {
    this.$section = $section;
    if (this.summaryMedia && this.summaryMediaHandler) {
      if (this.summaryMedia.removeEventListener) this.summaryMedia.removeEventListener('change', this.summaryMediaHandler);
      else this.summaryMedia.removeListener(this.summaryMediaHandler);
    }
    this.summaryMedia = window.matchMedia('(max-width: 798px)');
    this.summaryMediaHandler = () => this.initializeMobileSummary();
    if (this.summaryMedia.addEventListener) this.summaryMedia.addEventListener('change', this.summaryMediaHandler);
    else this.summaryMedia.addListener(this.summaryMediaHandler);
    this.initializeMobileSummary();

    $(document)
      .off('click.customCartPageRemove', '[data-cart-page-delete]')
      .on('click.customCartPageRemove', '[data-cart-page-delete]', function (event) {
        event.preventDefault();
        Shopify.theme.jsCart.removeFromCart($(this).data('line-item-key'));
      });

    $(document)
      .off('click.customCartPageQuantity', '[data-cart-page-quantity-minus], [data-cart-page-quantity-plus]')
      .on('click.customCartPageQuantity', '[data-cart-page-quantity-minus], [data-cart-page-quantity-plus]', function (event) {
        event.preventDefault();
        const $button = $(this);
        const $item = $button.closest('[data-line-item]');
        const $input = $item.find('[data-cart-page-quantity-value]');
        const currentQuantity = parseInt($input.val(), 10) || 1;
        const nextQuantity = $button.is('[data-cart-page-quantity-plus]') ? currentQuantity + 1 : currentQuantity - 1;

        if (nextQuantity < 1) return false;
        Shopify.theme.jsCart.changeCartLine($item.data('line-item'), nextQuantity);
        return false;
      });

    $(document)
      .off('click.customCartPageDetails', '[data-cart-page-item-toggle]')
      .on('click.customCartPageDetails', '[data-cart-page-item-toggle]', function (event) {
        event.preventDefault();
        const $button = $(this);
        const $meta = $button.siblings('.cartPageItemMeta');
        const $extraDetails = $meta.find('.cartPageItemMetaEntry').slice(2);
        const isExpanded = $button.attr('aria-expanded') === 'true';

        $button.attr('aria-expanded', String(!isExpanded));
        $button.find('span').text(isExpanded ? 'View personalizations' : 'Hide personalizations');
        $meta.toggleClass('is-expanded', !isExpanded);
        $extraDetails.stop(true, true)[isExpanded ? 'slideUp' : 'slideDown'](200);
      });

    $(document).off('keydown.customCartPage', '#cart_form').on('keydown.customCartPage', '#cart_form', function (event) {
      if (event.keyCode === 13 && !$(event.target).is('textarea')) {
        event.preventDefault();
        return false;
      }
    });
  },

  initializeMobileSummary: function () {
    if (this.summaryObserver) this.summaryObserver.disconnect();
    this.$section.removeClass('is-cart-page-active');

    if (!this.summaryMedia.matches) return;
    if (typeof IntersectionObserver === 'undefined') {
      this.$section.addClass('is-cart-page-active');
      return;
    }

    this.summaryObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        this.$section.toggleClass('is-cart-page-active', entry.isIntersecting);
      });
    }, { threshold: 0 });

    if (this.$section[0]) this.summaryObserver.observe(this.$section[0]);
  },

  notify: function (message, type) {
    if (typeof window.showThemeToast === 'function') {
      window.showThemeToast(message, type || 'error');
    } else if (message) {
      console[type === 'error' ? 'error' : 'log'](message);
    }
  },

  getErrorMessage: function (XMLHttpRequest) {
    let response = {};
    try {
      response = JSON.parse(XMLHttpRequest.responseText || '{}');
    } catch (error) {
      response = {};
    }
    return response.description || response.message || 'Something went wrong. Please try again.';
  },

  setProcessing: function (isProcessing) {
    const $content = this.$section.find('.cartPageContent');
    $content.toggleClass('is-processing', Boolean(isProcessing));
    $content.find('.cartPageProcessing').attr('aria-hidden', String(!isProcessing));
  },

  changeCartLine: function (lineID, quantity) {
    if (!lineID || this.$section.find('.cartPageContent').hasClass('is-processing')) return;
    this.setProcessing(true);

    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: { line: lineID, quantity: quantity },
      dataType: 'json'
    })
      .done((cart) => {
        if (typeof Shopify.theme.jsAjaxCart !== 'undefined') {
          Shopify.theme.jsAjaxCart.updateView();
        }

        this.updateView(cart, lineID, () => {
          this.setProcessing(false);
          this.notify(quantity === 0 ? 'Item removed from your cart.' : 'Cart quantity updated.', 'success');
        });
      })
      .fail((XMLHttpRequest) => {
        this.setProcessing(false);
        this.notify(this.getErrorMessage(XMLHttpRequest), 'error');
      });
  },

  removeFromCart: function (lineID) {
    this.changeCartLine(lineID, 0);
  },

  updateView: function (cart, lineID, callback) {
    $.ajax({
      dataType: 'html',
      cache: false,
      url: Shopify.routes.cart_url
    })
      .done((html) => {
        const $updatedContent = $(html).find('.cartPageContent').first();
        if ($updatedContent.length) {
          this.$section.find('.cartPageContent').replaceWith($updatedContent);
        }

        if (cart) {
          $('[data-bind="itemCount"]').text(cart.item_count);
          $('[data-ajax-cart-trigger]').toggleClass('has-cart-count', cart.item_count > 0);
        }

        if (Shopify.theme.currencyConverter) {
          Shopify.theme.currencyConverter.convertCurrencies();
        }

        if (typeof callback === 'function') callback();
      })
      .fail(() => {
        this.setProcessing(false);
        this.notify('The cart could not be refreshed. Please reload the page.', 'error');
      });
  },

  unload: function () {
    if (this.summaryObserver) this.summaryObserver.disconnect();
    if (this.summaryMedia && this.summaryMediaHandler) {
      if (this.summaryMedia.removeEventListener) this.summaryMedia.removeEventListener('change', this.summaryMediaHandler);
      else this.summaryMedia.removeListener(this.summaryMediaHandler);
    }
    $(document).off('.customCartPageRemove').off('.customCartPageQuantity').off('.customCartPageDetails');
    $(document).off('keydown.customCartPage', '#cart_form');
  }
};

/******/ })()
;
